import React from 'react';
import { AnyService } from '../../../types/service.type';
import ServiceCardHeader from './ServiceCardHeader';
import ServiceCardBody from './ServiceCardBody';
import ServiceCardActions from './ServiceCardActions';

export interface ServiceCardProps {
  service: AnyService;
  variant?: 'compact' | 'default' | 'detailed';
  showActions?: boolean;
  onActionClick?: (action: string) => void;
  customActions?: React.ReactNode;
  renderExtra?: (service: AnyService) => React.ReactNode;
  onClick?: () => void;
  className?: string;
}

const ServiceCard: React.FC<ServiceCardProps> = ({
  service,
  variant = 'default',
  showActions = true,
  onActionClick,
  customActions,
  renderExtra,
  onClick,
  className = '',
}) => {
  const isClickable = !!onClick;

  const variantClasses = {
    compact: 'p-4',
    default: 'p-5',
    detailed: 'p-6',
  };

  return (
    <div
      onClick={onClick}
      className={`
        bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700
        transition-all duration-200
        ${variantClasses[variant]}
        ${isClickable ? 'cursor-pointer hover:shadow-md hover:border-gray-300 dark:hover:border-gray-600' : 'hover:shadow-sm'}
        ${className}
      `}
    >
      {/* Header */}
      <ServiceCardHeader service={service} variant={variant} />

      {/* Body */}
      <ServiceCardBody 
        service={service} 
        variant={variant}
        renderExtra={renderExtra}
      />

      {/* Actions */}
      {showActions && (
        <ServiceCardActions
          service={service}
          variant={variant}
          onActionClick={onActionClick}
          customActions={customActions}
        />
      )}
    </div>
  );
};

export default ServiceCard;